/**
 * Presets for the dock plugin
 * @module
 */

export * as classic from './classic'
